export const PROBLEM_LOCKED_COLUMNS: readonly string[] = ['id', 'created_at', 'updated_at'];

export function isProblemLocked(column: string): boolean {
  return PROBLEM_LOCKED_COLUMNS.includes(column);
}
